

export class AlertSpecificationOutputByAlertGroupIdData implements IAlertSpecificationOutputByAlertGroupIdData {
    /** The auto-generated id of the alert specification master */
    alert_specification_id!: number;
    /** The auto-generated id of the alert master */
    alert_id!: number;
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The value common must be 2000 character max */
    value_common!: string;
    /** The alert name must be 2000 character max */
    alert_name!: string;
    /** The text must be 2000 character max */
    text!: string;
    /** The minimum value */
    min!: number;
    /** The maximum value */
    max!: number;
    /** The sms flag should be 1 or 0 */
    sms!: number;
    /** The email flag should be 1 or 0 */
    email!: number;
    /** status */
    status!: number;

    constructor(data?: IAlertSpecificationOutputByAlertGroupIdData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_specification_id = _data["alert_specification_id"];
            this.alert_id = _data["alert_id"];
            this.alert_group_id = _data["alert_group_id"];
            this.value_common = _data["value_common"];
            this.alert_name = _data["alert_name"];
            this.text = _data["text"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.sms = _data["sms"];
            this.email = _data["email"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AlertSpecificationOutputByAlertGroupIdData {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSpecificationOutputByAlertGroupIdData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_specification_id"] = this.alert_specification_id;
        data["alert_id"] = this.alert_id;
        data["alert_group_id"] = this.alert_group_id;
        data["value_common"] = this.value_common;
        data["alert_name"] = this.alert_name;
        data["text"] = this.text;
        data["min"] = this.min;
        data["max"] = this.max;
        data["sms"] = this.sms;
        data["email"] = this.email;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAlertSpecificationOutputByAlertGroupIdData {
    /** The auto-generated id of the alert specification master */
    alert_specification_id: number;
    /** The auto-generated id of the alert master */
    alert_id: number;
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The value common must be 2000 character max */
    value_common: string;
    /** The alert name must be 2000 character max */
    alert_name: string;
    /** The text must be 2000 character max */
    text: string;
    /** The minimum value */
    min: number;
    /** The maximum value */
    max: number;
    /** The sms flag should be 1 or 0 */
    sms: number;
    /** The email flag should be 1 or 0 */
    email: number;
    /** status */
    status: number;
}

